// src/components/Layout.js
import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Layout.css';

const Layout = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { logout } = useAuth();

  const isActive = (path) => location.pathname === path;

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="layout">
      <nav className="sidebar">
        <div className="logo">
          <h2>Trading Dashboard</h2>
        </div>

        <div className="nav-links">
          <Link
            to="/"
            className={isActive('/') ? 'nav-link active' : 'nav-link'}
          >
            <span className="icon"></span>
            Overview
          </Link>

          <Link
            to="/positions"
            className={isActive('/positions') ? 'nav-link active' : 'nav-link'}
          >
            <span className="icon"></span>
            Positions
          </Link>

          <Link
            to="/trades"
            className={isActive('/trades') ? 'nav-link active' : 'nav-link'}
          >
            <span className="icon"></span>
            Trade History
          </Link>

          <Link
            to="/symbols"
            className={isActive('/symbols') ? 'nav-link active' : 'nav-link'}
          >
            <span className="icon"></span>
            Symbol Analysis
          </Link>

          <Link
            to="/performance"
            className={isActive('/performance') ? 'nav-link active' : 'nav-link'}
          >
            <span className="icon"></span>
            Performance
          </Link>
        </div>

        <div className="sidebar-footer">
          <button className="logout-btn" onClick={handleLogout}>
            Sign Out
          </button>
        </div>
      </nav>

      <main className="main-content">
        {children}
      </main>
    </div>
  );
};

export default Layout;
